import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter__body" }
const _hoisted_2 = { class: "filter__main" }
const _hoisted_3 = { class: "filter__items" }
const _hoisted_4 = { class: "filter__items" }
const _hoisted_5 = { class: "filter__row" }
const _hoisted_6 = { class: "filter__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSWeeklyProductsFilter = _resolveComponent("FTSWeeklyProductsFilter")!
  const _component_FTSCountriesFilter = _resolveComponent("FTSCountriesFilter")!
  const _component_FTSOkatoFilter = _resolveComponent("FTSOkatoFilter")!
  const _component_FTSWeeklyPeriodField = _resolveComponent("FTSWeeklyPeriodField")!
  const _component_FTSWeeklyResponsibleOkatoField = _resolveComponent("FTSWeeklyResponsibleOkatoField")!
  const _component_FTSCumulativeTotalField = _resolveComponent("FTSCumulativeTotalField")!
  const _component_FTSAdditionalUnitsField = _resolveComponent("FTSAdditionalUnitsField")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_FTSFilterWrapperToogle = _resolveComponent("FTSFilterWrapperToogle")!
  const _component_FTSWeeklyGroupingFilter = _resolveComponent("FTSWeeklyGroupingFilter")!
  const _component_FTSPriceField = _resolveComponent("FTSPriceField")!
  const _component_FTSWeightField = _resolveComponent("FTSWeightField")!
  const _component_FTSTradeDirectionField = _resolveComponent("FTSTradeDirectionField")!
  const _component_FTSWeeklyMovementOfGoodsFilter = _resolveComponent("FTSWeeklyMovementOfGoodsFilter")!
  const _component_FTSFilterWrapper = _resolveComponent("FTSFilterWrapper")!

  return (_openBlock(), _createBlock(_component_FTSFilterWrapper, {
    class: "filter",
    onSearch: _ctx.searchFilter,
    onInit: _ctx.initFilter,
    onLoad: _ctx.loadFilter,
    filter: _ctx.filter,
    defaultFilter: _ctx.defaultFilter,
    filePrefixName: "weekly",
    isReadonly: _ctx.isReadonly,
    checkAdditionalValidation: (filter) => _ctx.checkAdditionalValidation(filter as TFTSWeeklyFilter),
    exportConfig: _ctx.exportConfig
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FTSWeeklyProductsFilter, {
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FTSCountriesFilter, {
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
              isRequiredStatisticsCountry: "",
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSOkatoFilter, {
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FTSWeeklyPeriodField, {
                modelValue: _ctx.filter.periods,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.periods) = $event)),
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_FTSWeeklyResponsibleOkatoField, {
                modelValue: _ctx.filter.finResponsibleOkatoIds,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.finResponsibleOkatoIds) = $event)),
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FTSCumulativeTotalField, {
                modelValue: _ctx.filter.isCumulativeTotal,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filter.isCumulativeTotal) = $event)),
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_FTSFilterWrapperToogle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FTSAdditionalUnitsField, {
                    modelValue: _ctx.filter.isAdditionalUnits,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.isAdditionalUnits) = $event)),
                    disabled: _ctx.isReadonly
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ComponentInput, {
                    modelValue: _ctx.filter.isCodeAdditionalUnits,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filter.isCodeAdditionalUnits) = $event)),
                    id: "code-additional-units",
                    type: "checkbox",
                    label: "Код доп. ед.",
                    mod: "checkbox-green",
                    disabled: _ctx.isReadonly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_FTSWeeklyGroupingFilter, {
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSFilterWrapperToogle, { class: "filter__indicators" }, {
              default: _withCtx(() => [
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isStatisticsPrice,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filter.isStatisticsPrice) = $event)),
                  id: "statistics-price",
                  type: "checkbox",
                  label: "Стат. стоимость",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isSumDollarsPayments,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filter.isSumDollarsPayments) = $event)),
                  id: "sum-dollars-payments",
                  type: "checkbox",
                  label: "Сумма там. платежей в долл.",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isPriceProduct,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filter.isPriceProduct) = $event)),
                  id: "price-product",
                  type: "checkbox",
                  label: "Цена товара",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isWeightProduct,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filter.isWeightProduct) = $event)),
                  id: "weight-product",
                  type: "checkbox",
                  label: "Вес товара",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isQuotaProduct,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filter.isQuotaProduct) = $event)),
                  id: "quota-product",
                  type: "checkbox",
                  label: "Квота",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_FTSPriceField, {
              modelValue: _ctx.filter.costInId,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filter.costInId) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSWeightField, {
              modelValue: _ctx.filter.weightId,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filter.weightId) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSTradeDirectionField, {
              modelValue: _ctx.filter.tradeDirectionId,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filter.tradeDirectionId) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSFilterWrapperToogle, null, {
              default: _withCtx(() => [
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isQuotaCurrencyDigitalCode,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filter.isQuotaCurrencyDigitalCode) = $event)),
                  id: "quota-currency-digital-code",
                  type: "checkbox",
                  label: "Цифр. код валюты квоты",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isQuotaCurrencyName,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.filter.isQuotaCurrencyName) = $event)),
                  id: "quota-currency-name",
                  type: "checkbox",
                  label: "Наим. валюты/ед. изм. квоты",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_FTSWeeklyMovementOfGoodsFilter, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.filter) = $event)),
          disabled: _ctx.isReadonly
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["onSearch", "onInit", "onLoad", "filter", "defaultFilter", "isReadonly", "checkAdditionalValidation", "exportConfig"]))
}